import { FuelType, FuelTypeName } from "../enums/FuelCode.enum";

export const isFuelTypeElectrical = (fuelType: string): boolean => fuelType.toUpperCase() == FuelType.Electric || fuelType.toUpperCase() == FuelTypeName.Electric;
